export default __webpack_public_path__ + "static/media/fem_11.7e551208.png";